import React from 'react';
import {ActivePathType} from 'commons/types/Types';

type EfeFlowContextType = {
    moduleStep: boolean;
    flow: ActivePathType;
    updateFlow: (data: ActivePathType) => void;
    updateModuleStep: (flag: boolean) => void;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const OnboardingFlowContext = React.createContext<EfeFlowContextType>({});

export function useFlowContext() {
    return React.useContext(OnboardingFlowContext);
}

export default OnboardingFlowContext;
